<template>
  <div class="container article">
    <div style="fontSize:16rpx ;fontWeight:700;color:black">用户管理</div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="用户ID"
                      prop="id">
          <el-input v-model="query.id"
                    placeholder="请输入用户ID"
                    style="width: 220px"
                    @input="fetchNoteList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="用户"
                      prop="user_keyword">
          <el-input v-model="query.user_keyword"
                    placeholder="请输入昵称或手机号或qq号或微信号"
                    style="width: 270px"
                    @input="fetchNoteList(true)"
                    clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="用户"
                      prop="user_keyword">
          <el-input v-model="query.user_keyword"
                    placeholder="请输入昵称或手机号"
                    style="width: 220px"
                    @input="fetchNoteList(true)"
                    clearable></el-input>
        </el-form-item> -->
        <el-form-item label="统计排序"
                      prop="status">
          <el-select v-model="query.statistic_order_type"
                     placeholder="请选择"
                     clearable
                     @change="fetchNoteList(true)"
                     style="width:200px;">
            <el-option v-for="item in filter.statistic_types"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="统计时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="fetchNoteList(true)"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="院校名称"
                      prop="education_college_keyword">
          <el-input v-model="query.education_college_keyword"
                    placeholder="请输入院校关键字代码/名"
                    style="width: 220px"
                    @input="fetchNoteList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="专业"
                      prop="education_major_keyword">
          <el-input v-model="query.education_major_keyword"
                    placeholder="请输入专业关键字代码/名"
                    style="width: 220px"
                    @input="fetchNoteList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="学院"
                      prop="education_academy_keyword">
          <el-input v-model="query.education_academy_keyword"
                    placeholder="请输入学院关键字代码/名"
                    style="width: 220px"
                    @input="fetchNoteList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="科目"
                      prop="education_subject_keyword">
          <el-input v-model="query.education_subject_keyword"
                    placeholder="请输入科目关键字代码/名"
                    style="width: 220px"
                    @input="fetchNoteList(true)"
                    clearable></el-input>
        </el-form-item>

        <el-form-item label="答疑服务"
                      prop="status">
          <el-select v-model="query.answer_card_onoff_status"
                     placeholder="请选择"
                     clearable
                     @change="fetchNoteList(true)"
                     style="width:90px;">
            <el-option v-for="item in filter.answer_types"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="预约1v1"
                      prop="status">
          <el-select v-model="query.tutoring_1v1_onoff_status"
                     placeholder="请选择"
                     clearable
                     @change="fetchNoteList(true)"
                     style="width:90px;">
            <el-option v-for="item in filter.tutoring_1v1_types"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否独家"
                      prop="status">
          <el-select v-model="query.single_cooperate_status"
                     placeholder="请选择"
                     clearable
                     @change="fetchNoteList(true)"
                     style="width:90px;">
            <el-option v-for="item in filter.single_types"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="合作等级"
                      prop="status">
          <el-select v-model="query.senior_cooperate_levels"
                     placeholder="请选择"
                     clearable
                     @change="fetchNoteList(true)"
                     style="width:90px;">
            <el-option v-for="item in filter.cooperateLeves"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="邀请人"
                      prop="referrer_user_keyword">
          <el-input v-model="query.referrer_user_keyword"
                    placeholder="请输入邀请人昵称"
                    style="width: 220px"
                    @input="fetchNoteList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="注册来源"
                      prop="register_source_id">
          <el-input v-model="query.register_source_id"
                    placeholder="请输入邀请人昵称"
                    style="width: 220px"
                    @input="fetchNoteList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="内部备注"
                      prop="id">
          <el-input v-model="query.inner_remark_keyword "
                    placeholder="请输入备注"
                    style="width: 220px"
                    @input="fetchNoteList(true)"
                    clearable></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">用户列表</h3>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="user_education_type"
                            @change="tabChange()">
              <el-radio-button v-for="(item, index) in filter.type"
                               :key="index"
                               :label="item.value">
                {{ item.label }}
              </el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-table :data="results"
                  border
                  v-if="user_education_type=='2'||user_education_type=='3'"
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="50"
                           align="center"> </el-table-column>
          <el-table-column prop="id"
                           width="80"
                           label="用户ID"
                           align="center">
          </el-table-column>
          <el-table-column prop="nickname"
                           width="180"
                           label="昵称(身份)"
                           show-overflow-tooltip
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       @click="handleLookUser(scope.row)">{{ scope.row.nickname? scope.row.nickname :'-'}} </el-link><span v-if="scope.row.user_virtual_type==1"
                    class="virBtn">虚拟</span></template>
          </el-table-column>
          <el-table-column prop="id"
                           width="80"
                           label="年份"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.recruit_info">{{ scope.row.recruit_info.recruit_year}}年</span></template>
          </el-table-column>

          <el-table-column prop="nickname"
                           width="380"
                           label="录取信息"
                           show-overflow-tooltip
                           align="left">
            <template slot-scope="scope">
              <span v-if="scope.row.recruit_info">{{scope.row.recruit_info.recruit_college_name}} | {{scope.row.recruit_info.recruit_academy_name}} |
                ({{scope.row.recruit_info.recruit_major_code}}){{scope.row.recruit_info.recruit_major_name}} |
                ({{scope.row.recruit_info.recruit_direction_code}}){{scope.row.recruit_info.recruit_direction_name}}</span></template>
          </el-table-column>

          <el-table-column prop="total_author_note_count"
                           label="合作等级"
                           align="center"
                           v-if="user_education_type=='2'">
            <template slot-scope="scope">
              <div @click="handleCooperate(scope.row)"> 
              <el-tag v-if="!scope.row.senior_cooperate_level"
                        type="info" >0级</el-tag>
              <el-tag v-if="scope.row.senior_cooperate_level==1"
                        type="warning">A级</el-tag>
                <el-tag v-if="scope.row.senior_cooperate_level==2"
                        type="success">B级</el-tag>
                <el-tag v-if="scope.row.senior_cooperate_level==3">C级</el-tag>
                <el-tag v-if="scope.row.senior_cooperate_level==4">D级</el-tag>
                <el-tag v-if="scope.row.senior_cooperate_level==5"
                        type="danger">E级</el-tag>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="id"
                           label="当前积分"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       @click="handleIntegral(scope.row)">{{ scope.row.overage ?scope.row.overage :0}}分</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_author_note_count"
                           label="笔记数量"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_author_note_count ?scope.row.total_author_note_count :0}}个</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_author_comment_count"
                           label="评论数量"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_author_comment_count ?scope.row.total_author_comment_count :0}}个</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_share_count"
                           label="分享次数"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_share_count ?scope.row.total_share_count :0}}次</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_invite_user_count"
                           label="邀请人数"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_invite_user_count ?scope.row.total_invite_user_count :0}}人</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_recommend_order_count"
                           label="推荐单数"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_recommend_order_count ?scope.row.total_recommend_order_count :0}}单</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_read_order_count"
                           label="付费资料"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_read_order_count ?scope.row.total_read_order_count :0}}单</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_video_order_count"
                           label="付费视频"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_video_order_count ?scope.row.total_video_order_count :0}}单</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_video_order_count"
                           label="答疑服务"
                           width="140"
                           align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center"> <span class="dot"
                      :style="{'background' :scope.row.answer_card_onoff_status==0 ?' #F56C6C' :'#67C23A'}"></span> <el-link type="primary">{{ scope.row.answer_card_onoff_status==0 ?'关闭中' :'已开启'}}
                </el-link>
                <div class="underline"></div>
                <el-link type="primary">{{ scope.row.total_card_order_count?scope.row.total_card_order_count:0}}单</el-link>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="total_video_order_count"
                           label="预约1v1"
                           width="140"
                           align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center"> <span class="dot"
                      :style="{'background' :scope.row.tutoring_1v1_onoff_status==0 ?' #F56C6C' :'#67C23A'}"></span> <el-link type="primary">{{ scope.row.tutoring_1v1_onoff_status==0 ?'关闭中' :'已开启'}}
                </el-link>
                <div class="underline"></div>
                <el-link type="primary">{{ scope.row.total_onetoone_order_count?scope.row.total_onetoone_order_count:0}}单</el-link>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="total_profit_amount"
                           label="累计收益"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       @click="handleProfit(scope.row)">{{ scope.row.total_profit_amount ?scope.row.total_profit_amount :0}}元</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="single_cooperate_status"
                           label="是否独家"
                           align="center">
            <template slot-scope="scope">
              <el-image src="https://upload.kaoyanbox.net/130664ae97fee64e5e84acd3ab2c6ca1.png"
                        style="width:16px;height:16px"
                        v-if="scope.row.single_cooperate_status==1"></el-image>
              <span v-else> -</span>
            </template>
          </el-table-column>
          <el-table-column prop="show_status"
                           label="显示状态"
                           align="center">
            <template slot-scope="scope">

              <el-link type="success"
                       v-if="scope.row.show_status==1"
                       @click="handleStatus(scope.row)">展示</el-link>
              <el-link type="info"
                       v-if="scope.row.show_status==2"
                       @click="handleStatus(scope.row)">隐藏</el-link>
              <el-link type="danger"
                       v-if="scope.row.show_status==3"
                       @click="handleStatus(scope.row)">封禁</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="referrer_nickname"
                           label="邀请人"
                           show-overflow-tooltip
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       v-if="scope.row.senior_apply_invite_info">{{scope.row.senior_apply_invite_info}}</el-link>
              <el-link type="primary"
                       v-else-if="scope.row.referrer_nickname">{{scope.row.referrer_nickname}}</el-link>
              <el-link type="primary"
                       v-else-if="scope.row.admin_inviter_nickname">{{scope.row.admin_inviter_nickname}}</el-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="最近发布时间"
                           align="center"
                           width="140"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.last_author_note_time
                  ? $moment(scope.row.last_author_note_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="最近分享时间"
                           align="center"
                           width="140"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.last_share_time
                  ? $moment(scope.row.last_share_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="最近邀请时间"
                           align="center"
                           width="140"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.last_invite_time
                  ? $moment(scope.row.last_invite_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="最近推荐时间"
                           align="center"
                           width="140"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.last_recommend_order_time
                  ? $moment(scope.row.last_recommend_order_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="最近登录时间"
                           align="center"
                           width="140"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.note_last_login_time
                  ? $moment(scope.row.note_last_login_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="认证提交时间"
                           align="center"
                           width="140"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.senior_apply_create_time
                  ? $moment(scope.row.senior_apply_create_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="认证通过时间"
                           align="center"
                           width="140"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.senior_apply_access_time
                  ? $moment(scope.row.senior_apply_access_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="注册时间"
                           align="center"
                           width="140"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.register_time
                  ? $moment(scope.row.register_time).format("YYYY-MM-DD HH:mm:ss")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="内部备注"
                           align="center"
                           width="140"
                           fixed="right">
            <template slot-scope="scope">
              <el-input v-model="scope.row.inner_remark"
                        placeholder="请输入备注"
                        @blur="innerRemark($event, scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           width="120"
                           fixed="right">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToPersonal(scope.row)">主页</el-link>
              <el-link type="danger"
                       :underline="false"
                       @click="handleBanned(scope.row)"
                       v-if="scope.row.show_status==2||scope.row.show_status==1">封禁</el-link>
              <el-link type="warning"
                       v-if="scope.row.show_status==3"
                       @click="handleNoBanned(scope.row)">解封</el-link>
            </template>
          </el-table-column>
        </el-table>

        <el-table :data="results"
                  border
                  v-if="user_education_type=='1'||user_education_type=='4'"
                  style="width: 100%"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="50"
                           align="center"> </el-table-column>
          <el-table-column prop="id"
                           width="80"
                           label="用户ID"
                           align="center">
          </el-table-column>
          <el-table-column prop="nickname"
                           width="180"
                           label="昵称"
                           show-overflow-tooltip
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       @click="handlUserLook(scope.row)">{{ scope.row.nickname? scope.row.nickname :'-'}}</el-link> <span v-if="scope.row.user_virtual_type==1"
                    class="virBtn">虚拟</span></template>
          </el-table-column>
          <el-table-column prop="id"
                           width="80"
                           label="年份"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.apply_info">{{ scope.row.apply_info.apply_year !=null ?scope.row.apply_info.apply_year +'年' :'-'}}</span></template>
          </el-table-column>

          <el-table-column prop="nickname"
                           width="350"
                           label="报录信息"
                           show-overflow-tooltip
                           align="left">
            <template slot-scope="scope">
              <div v-if="scope.row.apply_info">
                <span v-if="scope.row.apply_info.apply_college_name">{{scope.row.apply_info.apply_college_name}}</span>
                <span v-if="scope.row.apply_info.apply_academy_name"> | {{scope.row.apply_info.apply_academy_name}}</span>
                <span v-if="scope.row.apply_info.apply_major_code"> | ({{scope.row.apply_info.apply_major_code}}){{scope.row.apply_info.apply_major_name}}</span>
                <span v-if="scope.row.apply_info.apply_direction_code"> | ({{scope.row.apply_info.apply_direction_code}}){{scope.row.apply_direction_name}}</span>

              </div>

            </template>
          </el-table-column>
          <el-table-column prop="id"
                           width="80"
                           label="当前积分"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       @click="handleIntegral(scope.row)">{{ scope.row.overage ?scope.row.overage :0}}分</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_author_note_count"
                           width="70"
                           label="笔记数量"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_author_note_count ?scope.row.total_author_note_count :0}}个</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_author_comment_count"
                           width="70"
                           label="评论数量"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_author_comment_count ?scope.row.total_author_comment_count :0}}个</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_order_count"
                           width="70"
                           label="订单数量"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_order_count ?scope.row.total_order_count :0}}个</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_order_spend_amount"
                           width="70"
                           label="累计消费"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.total_order_spend_amount ?scope.row.total_order_spend_amount :0}}元</span>
            </template>
          </el-table-column>
          <el-table-column prop="total_share_count"
                           width="70"
                           label="分享次数"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_share_count ?scope.row.total_share_count :0}}次</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="total_invite_user_count"
                           width="70"
                           label="邀请人数"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_invite_user_count ?scope.row.total_invite_user_count :0}}人</el-link>
            </template>
          </el-table-column>

          <el-table-column prop="total_recommend_order_count"
                           width="70"
                           label="推荐单数"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary">{{ scope.row.total_recommend_order_count ?scope.row.total_recommend_order_count :0}}单</el-link>
            </template>
          </el-table-column>

          <el-table-column prop="total_profit_amount"
                           width="70"
                           label="累计收益"
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       @click="handleProfit(scope.row)">{{ scope.row.total_profit_amount ?scope.row.total_profit_amount :0}}元</el-link>
            </template>
          </el-table-column>

          <el-table-column prop="referrer_nickname"
                           width="120"
                           label="邀请人"
                           show-overflow-tooltip
                           align="center">
            <template slot-scope="scope">
              <el-link type="primary"
                       v-if="scope.row.referrer_nickname">{{scope.row.referrer_nickname}}</el-link>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="最近发布时间"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.last_author_note_time
                  ? $moment(scope.row.last_author_note_time).format("YYYY-MM-DD")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="最近分享时间"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.last_share_time
                  ? $moment(scope.row.last_share_time).format("YYYY-MM-DD")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="最近邀请时间"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.last_invite_time
                  ? $moment(scope.row.last_invite_time).format("YYYY-MM-DD")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="最近推荐时间"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.last_recommend_order_time
                  ? $moment(scope.row.last_recommend_order_time).format("YYYY-MM-DD")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="最近登录时间"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.note_last_login_time
                  ? $moment(scope.row.note_last_login_time).format("YYYY-MM-DD")
                  : "-"
              }}
            </template>
          </el-table-column>

          <el-table-column label="注册时间"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.register_time
                  ? $moment(scope.row.register_time).format("YYYY-MM-DD")
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="注册来源"
                           align="center"
                           width="100"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{
                scope.row.register_source_id
                  ?  scope.row.register_source_id
                  : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="内部备注"
                           align="center"
                           width="140"
                           fixed="right"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input v-model="scope.row.inner_remark"
                        placeholder="请输入备注"
                        @blur="innerRemark($event, scope.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           width="120"
                           fixed="right">
            <template slot-scope="scope">
              <el-link type="primary"
                       :underline="false"
                       @click="handleToPersonal(scope.row)">主页</el-link>
              <el-link type="danger"
                       :underline="false"
                       @click="handleBanned(scope.row)"
                       v-if="scope.row.show_status==2||scope.row.show_status==1">封禁</el-link>
              <el-link type="warning"
                       v-if="scope.row.show_status==3"
                       @click="handleNoBanned(scope.row)">解封</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <div class="left">
          <span>已选0条</span>
          <span class="xian"></span>
          <span style="marginRight:16px">批量</span>
          <p class="batch"
             @click="handleDelte()">删除</p>

        </div>
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange">
        </el-pagination>
      </div>
    </div>
    <div class="results card"
         v-if="createDatetime !=''&&createDatetime !=null&&user_education_type=='2'">
      <p>数据统计</p>
      <div class="staticBox">
        <div class="boxItem">
          <p class="titles">新增活跃</p>
          <p class="desc">+{{allList.sum_active_user_count}}人</p>
        </div>
        <div class="boxItem">
          <p class="titles">积分</p>
          <p class="desc">+{{allList.sum_integral_point}}分</p>
        </div>
        <div class="boxItem">
          <p class="titles">笔记</p>
          <p class="desc">+{{allList.sum_author_note_count}}个</p>
        </div>
        <div class="boxItem">
          <p class="titles">评论</p>
          <p class="desc">+{{allList.sum_author_comment_count}}个</p>
        </div>
        <div class="boxItem">
          <p class="titles">分享</p>
          <p class="desc">+{{allList.sum_share_count}}次</p>
        </div>
        <div class="boxItem">
          <p class="titles">邀请</p>
          <p class="desc">+{{allList.sum_invite_user_count}}人</p>
        </div>
        <div class="boxItem">
          <p class="titles">推荐</p>
          <p class="desc">+{{allList.sum_recommend_order_count}}单</p>
        </div>
        <div class="boxItem">
          <p class="titles">资料</p>
          <p class="desc">+{{allList.sum_read_order_count }}单</p>
        </div>
        <div class="boxItem">
          <p class="titles">课程</p>
          <p class="desc">+{{allList.sum_video_order_count }}单</p>
        </div>
        <div class="boxItem">
          <p class="titles">答疑开通</p>
          <p class="desc">+{{allList.sum_answer_open_count }}人</p>
        </div>
        <div class="boxItem">
          <p class="titles">答疑订单</p>
          <p class="desc">+{{allList.sum_answer_order_count  }}单</p>
        </div>
        <div class="boxItem">
          <p class="titles">1v1开通</p>
          <p class="desc">+{{allList.sum_onetoone_open_count  }}单</p>
        </div>
        <div class="boxItem">
          <p class="titles">1v1订单</p>
          <p class="desc">+{{allList.sum_onetoone_order_count   }}单</p>
        </div>
        <div class="boxItem">
          <p class="titles">收益</p>
          <p class="desc">+{{allList.sum_profit_amount}}元</p>
        </div>
        <div class="boxItem">
          <p class="titles">独家</p>
          <p class="desc">+{{allList.sum_single_start_count}}人</p>
        </div>
      </div>

    </div>

    <div class="results card"
         v-if="createDatetime !=''&&createDatetime !=null&&user_education_type=='1'">
      <p>数据统计</p>
      <div class="staticBox">
        <div class="boxItem">
          <p class="titles">新增活跃</p>
          <p class="desc">+{{allList.sum_active_user_count}}人</p>
        </div>
        <div class="boxItem">
          <p class="titles">积分</p>
          <p class="desc">+{{allList.sum_integral_point}}分</p>
        </div>
        <div class="boxItem">
          <p class="titles">笔记</p>
          <p class="desc">+{{allList.sum_author_note_count}}个</p>
        </div>
        <div class="boxItem">
          <p class="titles">评论</p>
          <p class="desc">+{{allList.sum_author_comment_count}}个</p>
        </div>
        <div class="boxItem">
          <p class="titles">订单</p>
          <p class="desc">+{{allList.sum_order_count }}单</p>
        </div>
        <div class="boxItem">
          <p class="titles">消费</p>
          <p class="desc">+{{allList.sum_order_spend_amount}}元</p>
        </div>
        <div class="boxItem">
          <p class="titles">分享</p>
          <p class="desc">+{{allList.sum_share_count}}次</p>
        </div>
        <div class="boxItem">
          <p class="titles">邀请</p>
          <p class="desc">+{{allList.sum_invite_user_count}}人</p>
        </div>
        <div class="boxItem">
          <p class="titles">推荐</p>
          <p class="desc">+{{allList.sum_recommend_order_count}}单</p>
        </div>

      </div>

    </div>
    <Integral :rowId="rowId"
              :visible="visible"
              @close="closeIntegarl()" />
    <UserSeniorMess :visible="seniorVisible"
                    :rowDetail="rowDetail"
                    @close="seniorClose()" />
    <UserMess :visible="userVisible"
              :rowDetail="rowDetail"
              @close="userClose()" />
    <UserDetail :visible="detailVisible"
                :rowId="rowId"
                @close="detailClose()" />
    <AccumulateDetail :visible="accumlateVisible"
                      :rowId="rowId"
                      @close="accumulateClose()" />
    <DetailLookSync :isVisible="lookDetailVisible"
                    @close="lookDetailClose"
                    :rowDetail="rowDetail" />
    <!-- 修改显示状态 -->
    <el-dialog title="修改显示状态"
               :close-on-click-modal="false"
               :visible.sync="dialogStatusVisible"
               @close="StatusClose()"
               @open="StatusOpen()"
               width="450px">
      <el-form ref="FormSenior"
               label-width="63px"
               class="userForm"
               style="marginLeft:-30px;">
        <el-form-item label="状态">
          <el-radio-group v-model="FormSenior.expandStatus">
            <el-radio :label="1">展示</el-radio>
            <el-radio :label="2">隐藏</el-radio>
            <el-radio :label="3">封禁</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>

      <div class="footer">
        <div class="cancle"
             @click="StatusClose()">取消</div>
        <div class="confirm"
             @click="StatusSubmit()">确认</div>
      </div>

    </el-dialog>
    <!-- 修改合作等级 -->
    <el-dialog title="合作等级修改"
               :close-on-click-modal="false"
               :visible.sync="dialogCooperateVisible"
               @close="cooperateClose()"
               @open="cooperateOpen()"
               width="450px">
      <el-form ref="FormSenior"
               label-width="100px"
               class="dataForm"
               style="marginLeft:-30px;">
        <el-form-item label="合作等级"
                      prop="status">
          <el-select v-model="dataForm.cooperate_level"
                     placeholder="请选择"
                     clearable
                     @change="fetchNoteList(true)"
                     style="width:90px;">
            <el-option v-for="item in filter.cooperateLeves"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <div class="footer">
        <div class="cancle"
             @click="cooperateClose()">取消</div>
        <div class="confirm"
             @click="cooperateSubmit()">确认</div>
      </div>

    </el-dialog>

  </div>
</template>

<script>
import {
  noteUserList,
  noteUserDelete,
  noteUserForite,
  putNoteUser,
  seniorUpdate,
} from '@/api/senior'

import Integral from '@/components/dialog/senior/integral'
import UserSeniorMess from '@/components/dialog/senior/userSeniorMess'
import UserMess from '@/components/dialog/senior/userMess'
import UserDetail from '@/components/dialog/senior/userDetail'
import AccumulateDetail from '@/components/dialog/senior/accumulateDetail'
import DetailLookSync from '@/components/dialog/DetailLookSync'
export default {
  components: {
    Integral,
    UserSeniorMess,
    UserMess,
    AccumulateDetail,
    UserDetail,
    DetailLookSync,
  },
  data() {
    return {
      dataForm: { cooperate_level: '' },
      dialogCooperateVisible: false,
      lookDetailVisible: false,
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
      },
      user_education_type: '2',
      detailVisible: false,
      accumlateVisible: false,
      rowId: null,

      filter: {
        type: [
          { label: '学长', value: '2' },
          { label: '学员', value: '1' },
          { label: '学长虚拟', value: '3' },
          { label: '学员虚拟', value: '4' },
        ],
        educate_types: [
          { label: '学员', value: '0' },
          { label: '学长', value: '1' },
        ],
        statistic_types: [
          { label: '最近发布时间倒序', value: '1' },
          { label: '最近分享时间倒序', value: '2' },
          { label: '最近邀请时间倒序', value: '3' },
          { label: '最近推荐时间倒序', value: '4' },
          { label: '最近登录时间倒序', value: '5' },
          { label: '注册时间倒序', value: '6' },
          { label: '当前积分倒序', value: '7' },
          { label: '笔记数量倒序', value: '8' },
          { label: '邀请人数倒序', value: '9' },
          { label: '推荐单数倒序', value: '10' },
          { label: '累计收益倒序', value: '11' },
        ],
        answer_types: [
          { label: '开启', value: '1' },
          { label: '关闭', value: '0' },
        ],
        tutoring_1v1_types: [
          { label: '开启', value: '1' },
          { label: '关闭', value: '0' },
        ],
        single_types: [
          { label: '否', value: '0' },
          { label: '是', value: '1' },
        ],
        cooperateLeves: [
          { label: 'A', value: '1' },
          { label: 'B', value: '2' },
          { label: 'C', value: '3' },
          { label: 'D', value: '4' },
          { label: 'E', value: '5' },
        ],
      },
      createDatetime: '',
      results: [],
      pageTotal: 0,
      chooseList: [],
      rowId: null,
      visible: false,
      seniorVisible: false,
      userVisible: false,
      dialogStatusVisible: false,
      rowDetail: {},
      FormSenior: { expandStatus: null },
      allList: [],
      cooperateDetail: {},
    }
  },
  created() {
    this.$store.dispatch('getAllColleges')
    this.$store.dispatch('getAdminList')
    this.$store.dispatch('getAllColleges')
    this.fetchNoteList()
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.statistic_start_time = this.$moment(value[0]).valueOf()
        this.query.statistic_end_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.statistic_start_time = ''
        this.query.statistic_end_time = ''
        this.fetchNoteList(true)
      }
    },
  },
  methods: {
    handleCooperate(row) {
      this.cooperateDetail = row
      this.dataForm.cooperate_level = row.senior_cooperate_level + ''
      this.dialogCooperateVisible = true
    },
    cooperateClose() {
      this.dialogCooperateVisible = false
    },
    cooperateSubmit() {
      let data = {
        id: this.cooperateDetail.senior_id,
      }
      data.cooperate_level = this.dataForm.cooperate_level

      seniorUpdate(data).then((res) => {
        this.cooperateClose()
        this.fetchNoteList()
        this.$message.success(`修改成功`)
      })
    },
    cooperateOpen() {
      this.dialogCooperateVisible = true
    },
    lookDetailClose() {
      this.lookDetailVisible = false
    },
    handleToPersonal(row) {
      this.lookDetailVisible = true
      this.rowDetail = row
    },
    handleProfit(item) {
      this.accumlateVisible = true
      this.rowId = item.uid
    },
    innerRemark(e, item) {
      putNoteUser({
        id: item.id,
        inner_remark: item.inner_remark,
      }).then((res) => {})
    },
    detailClose() {},
    accumulateClose() {
      this.accumlateVisible = false
    },
    handleStatus(row) {
      this.dialogStatusVisible = true
      this.rowDetail = row
      this.FormSenior.expandStatus = row.show_status
    },
    StatusClose() {
      this.dialogStatusVisible = false
    },
    StatusOpen() {
      this.dialogStatusVisible = true
    },
    StatusSubmit() {
      noteUserForite({
        id: this.rowDetail.id,
        show_status: this.FormSenior.expandStatus,
      }).then((res) => {
        this.fetchNoteList()
        this.dialogStatusVisible = false
      })
    },
    closeIntegarl() {
      this.visible = false
    },
    seniorClose() {
      this.seniorVisible = false
    },
    userClose() {
      this.userVisible = false
    },
    handleIntegral(row) {
      this.rowId = row.uid
      this.visible = true
    },
    handleLookUser(row) {
      this.rowDetail = row
      this.seniorVisible = true
    },
    handlUserLook(row) {
      this.rowDetail = row
      this.userVisible = true
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    handleBanned(row) {
      this.$confirm('确定要将此号封禁吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          noteUserForite({
            id: row.id,
            show_status: 3,
          }).then((res) => {
            this.fetchNoteList()
          })
        })
        .catch(() => {})
    },
    handleNoBanned(row) {
      this.$confirm('确定要将此号解封吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          noteUserForite({
            id: row.id,
            show_status: 1,
          }).then((res) => {
            this.fetchNoteList()
          })
        })
        .catch(() => {})
    },
    reset() {
      this.results = []
      this.pageTotal = 0
      this.query.pageIndex = 1
    },
    tabChange() {
      this.reset()
      this.fetchNoteList(true)
    },
    // 笔记用户列表
    fetchNoteList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      if (this.user_education_type == '3') {
        this.query.user_education_type = '0'
        this.query.user_virtual_type = '1'
      } else if (this.user_education_type == '4') {
        this.query.user_education_type = '1'
        this.query.user_virtual_type = '1'
      } else {
        this.query.user_virtual_type = '0'
        this.query.user_education_type = this.user_education_type
      }
      noteUserList(this.query).then((res) => {
        this.results = res.list || []
        this.allList = res
        this.pageTotal = res.count
      })
    },
    //批量删除
    handleDelte() {
      if (this.chooseList.length == 0) {
        this.$message.error(`至少选择一条数据`)
        return
      }
      let data = {
        ids: [],
      }
      this.chooseList.map((item) => {
        data.ids.push(item.id)
      })
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          noteUserDelete(data).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchNoteList()
          })
        })
        .catch(() => {})
    },

    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchNoteList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchNoteList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      setTimeout(() => {
        this.fetchArticleList()
      }, 20)
    },
  },
}
</script>

<style scoped lang="less">
::v-deep .el-table__fixed-right {
  background: #fff;
  z-index: 99 !important; /* 数值需高于滚动内容的z-index */
}
.virBtn {
  display: inline-block;
  text-align: 34px;
  width: 34px;
  font-size: 10px;
  height: 22px;
  line-height: 22px;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #cccccc;
}
.article {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    // box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 101%;
    height: 40px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }

      /deep/ .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
        box-shadow: none !important;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .search-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }

    .filter-item {
      display: flex;

      .label {
        line-height: 32px;
        margin-right: 10px;
      }
      .values {
        display: flex;
        flex-wrap: wrap;
        flex: 1;
      }
      .value-item {
        height: 32px;
        line-height: 32px;
        border-radius: 4px;
        padding: 0 10px;
        margin-right: 5px;
        cursor: pointer;

        &.active {
          color: #fff;
          background: #409eff;
        }
      }
    }
  }
  .results {
    margin-top: 10px;
    padding-right: 32px;

    .title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
      display: flex;
      flex-wrap: wrap;
      margin-right: -15px;
      .dot {
        margin-right: -5px;
        display: inline-block;
        width: 6px;
        height: 6px;
        background: #67c23a;
        border-radius: 50%;
      }
      .cooperate {
        width: 16px;
        height: 16px;
      }
      .underline {
        // margin-top: 5px;
        width: 1px;
        height: 14px;
        background: #409eff;
      }
    }
    .material-item {
      margin-right: 15px;
      margin-bottom: 15px;
    }
    .footer {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      .left {
        cursor: pointer;
        display: flex;
        align-items: center;
        .xian {
          margin-left: 16px;
          margin-right: 16px;
          width: 1px;
          height: 20px;
          background: #dcdfe6;
          border-radius: 0px 0px 0px 0px;
        }
        .batch {
          text-align: center;
          line-height: 26px;
          width: 46px;
          height: 26px;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #f56c6c;
          font-weight: 400;
          font-size: 13px;
          color: #f56c6c;
        }
      }
    }
    .el-link {
      margin: 0 8px;
    }
    .item-table-column {
      text-align: left;
    }
  }
  .staticBox {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    width: 1100px;

    min-height: 170px;
    .boxItem {
      margin-right: 14px;
      width: 100px;
      height: 70px;
      background: #f5f5f5;
      border-radius: 4px 4px 4px 4px;
      display: flex;
      flex-flow: column;
      justify-content: center;
      align-items: flex-start;
      .titles {
        margin-left: 14px;
        margin-bottom: 5px;
        font-size: 14px;
      }
      .desc {
        margin-left: 14px;
        font-size: 18px;
        font-weight: 700;
      }
    }
  }
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }
}
.tag-wrap {
  text-align: left;
  width: 100%;
  min-height: 30px;
}
.el-tag {
  margin: 0px 5px;
}
.footer {
  display: flex;
  justify-content: flex-end;
  .cancle {
    text-align: center;
    font-size: 14px;
    width: 56px;
    height: 36px;
    line-height: 36px;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #dcdfe6;
    margin-right: 10px;
  }
  .confirm {
    text-align: center;
    width: 56px;
    height: 36px;
    font-size: 14px;
    line-height: 36px;
    color: #fff;
    background: #1f86fe;
    border-radius: 4px 4px 4px 4px;
  }
}
</style>
